import { render, staticRenderFns } from "./goto.vue?vue&type=template&id=4864b4f3&"
import script from "./goto.vue?vue&type=script&lang=js&"
export * from "./goto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports